import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=77ce66ac&scoped=true"
import script from "./StandardTable.vue?vue&type=script&lang=js"
export * from "./StandardTable.vue?vue&type=script&lang=js"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=77ce66ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ce66ac",
  null
  
)

export default component.exports